import { Button, Flex, Table } from "antd";
import TagBordered from "../../../../../../../../atom/TagBordered";

import { getPercentValue } from "../../../../../../../../utils/helper/general";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { faBookmark as faBookmarkSolid } from "@fortawesome/free-solid-svg-icons";
import { faBookmark as faBookmarkRegular } from "@fortawesome/free-regular-svg-icons";
import { ReactComponent as ActionMenuDefault } from "../../images/action_menu_default.svg";
import { ReactComponent as ActionMenuActive } from "../../images/action_menu_active.svg";

const TableProducts = ({
  disableButtonFavorite,
  favoriteFinancialProducts,
  filteredProducts,
  handleActionClick,
  handleCardClick,
  handleToggleFavorite,
  hideColumnAction,
  listProductsActive,
  loading,
}) => {
  const columns = [
    {
      render: allValues => (
        <a onClick={() => handleCardClick(allValues._id)}>
          {allValues.name === "N/A" ? allValues.ticker : allValues.name}
        </a>
      ),
      sorter: (a, b) => a.name.localeCompare(b.name),
      title: "Name",
    },
    {
      render: allValues =>
        allValues.ticker && allValues.ticker !== allValues.name
          ? allValues.ticker
          : "N/A",
      sorter: (a, b) => (a.ticker ?? "").localeCompare(b.ticker ?? ""),
      title: "Ticker",
    },
    {
      align: "right",
      render: allValues =>
        getPercentValue(
          allValues.properties?.mcExpectedReturn ??
            Math.round(allValues.Return * 1000) / 10
        ),
      sorter: (a, b) =>
        (a.properties?.mcExpectedReturn ?? a.Return) -
        (b.properties?.mcExpectedReturn ?? b.Return),
      title: "Return",
      width: 120,
    },
    {
      align: "right",
      render: allValues =>
        getPercentValue(
          allValues.properties?.mcVolatilityReturn ??
            Math.round(allValues.RiskNumber * 1000) / 10
        ),
      sorter: (a, b) =>
        (a.properties?.mcVolatilityReturn ?? a.RiskNumber) -
        (b.properties?.mcVolatilityReturn ?? b.RiskNumber),
      title: "Risk Number",
      width: 140,
    },
    {
      dataIndex: "broadCategory",
      render: broadCategory =>
        broadCategory && <TagBordered label={broadCategory} />,
      sorter: (a, b) =>
        (a.broadCategory ?? "").localeCompare(b.broadCategory ?? ""),
      title: "Category",
    },
    {
      align: "right",
      hidden: hideColumnAction,
      render: allValues => (
        <Flex align="center" gap={16} justify="end">
          <Button
            disabled={disableButtonFavorite}
            icon={
              <FontAwesomeIcon
                icon={
                  (favoriteFinancialProducts ?? []).includes(allValues._id)
                    ? faBookmarkSolid
                    : faBookmarkRegular
                }
              />
            }
            onClick={() => handleToggleFavorite(allValues._id)}
            size="small"
            type="text"
          />

          {handleActionClick && (
            <Button
              icon={
                listProductsActive?.includes(allValues._id) ? (
                  <ActionMenuActive />
                ) : (
                  <ActionMenuDefault />
                )
              }
              onClick={() => handleActionClick(allValues)}
              shape="circle"
              size="small"
              style={{ height: "fit-content", minHeight: "unset" }}
              type="text"
            />
          )}
        </Flex>
      ),
      title: "Action",
      width: 70,
    },
  ].filter(it => !it.hidden);

  return (
    <Table
      columns={columns}
      dataSource={filteredProducts?.map(it => ({
        ...it,
        key: it._id,
      }))}
      loading={loading}
      pagination={false}
      size="small"
    />
  );
};

export default TableProducts;
